import React, { useEffect } from 'react';
import { ThemeProvider } from '../../react-app/theme/ThemeProvider';
import App from '../../react-app/App';

declare global {
  interface Window {
    __DIAGRAM_ID__?: string;
    TestHarness?: unknown;
    TestHarnessReady?: boolean;
    __testReady?: boolean;
  }
}

const TestCanvasPage: React.FC = () => {
  window.__DIAGRAM_ID__ = 'test';

  useEffect(() => {
    let cancelled = false;
    const waitForHarness = () => {
      if (cancelled) return;
      const h = window.TestHarness;
      if (h) {
        window.TestHarnessReady = true;
        window.__testReady = true;
        return;
      }
      setTimeout(waitForHarness, 50);
    };
    waitForHarness();
    return () => { cancelled = true; delete window.TestHarnessReady; delete window.__testReady; };
  }, []);

  return (
    <ThemeProvider defaultMode="light">
      <App />
    </ThemeProvider>
  );
};

export default TestCanvasPage;
